import { Box, Text, VStack } from '@chakra-ui/react'
import Footer from '../components/Footer'
import ScheduleTable from '../components/ScheduleTable'
import { useTranslation } from 'react-i18next'

const SchedulePage = () => {
  const { t } = useTranslation()

  return (
    <>
        <Box
            bgGradient={'linear(to-tr, pink.100, orange.200)'}
            width={'100%'}
            position="relative"
            padding={{ base: '10vh 5vw', md: '12vh 10vw' }}
            >
                <VStack spacing={2} maxWidth="1400px" margin="0 auto">
                    <Text
                        fontSize={{ base: '2xl', md: '3xl' }}
                        fontFamily={'heading'}
                        fontWeight={'bold'}
                        padding={'2vh 0'}
                        >{t('schedule.title')}</Text>

                    <Text
                        fontSize={{ base: 'xl', md: '2xl' }}
                        fontFamily="heading"
                        color="purple.800"
                        marginBottom={{ base: 4, md: 6 }}
                    >
                        {t('schedule.season')}
                    </Text>

                    <ScheduleTable />
                        
                </VStack>

        </Box>
        <Footer></Footer>
      
    </>
  )
}

export default SchedulePage
